var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BlogHeader"},[_c('blog-avatar',{attrs:{"blog":_vm.blog,"w":200,"h":200}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.blog.title))]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.cleanDesc))]),_vm._v(" "),_c('p',[_c('follow-button',{attrs:{"blog":_vm.blog}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b84f8e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blogs/BlogHeader.vue
// module id = S9Gm
// module chunks = 0